import { useState, useEffect } from 'react';
import * as Store from '@apply/store';
import { Question, QuestionType, PageQuestionProps } from '@apply/ui';
import { connect } from 'react-redux';
import { BuildRentTypeOptions } from '@apply/constants';

const BuildRentTypeSelect: React.FC<PageQuestionProps> = ({ onQuestionValidate, submitted, property, onChange, required }) => {
    const [selectList, set_selectList] = useState<{ value: number; display: string }[]>();

    useEffect(() => {
        let tempList = [{ value: undefined, display: '' }];
        const options = [
            ...BuildRentTypeOptions.map((o) => {
                return {
                    value: o.id,
                    display: o.question,
                };
            }),
        ];
        tempList = tempList.concat(options);
        set_selectList(tempList);
    }, [property?.address?.state]);

    return (
        <div className='form-group'>
            <div className='row'>
                <Question
                    type={QuestionType.RowSelect}
                    submitted={submitted}
                    selector='buildRentTypeId'
                    styleName='ungrouped'
                    onQuestionValidate={onQuestionValidate}
                    values={selectList}
                    value={property.rental?.buildRentTypeId?.toString()}
                    onChange={(e) => {
                        onChange(property.guid, e);
                    }}
                    required={required}
                >
                    Will new square footage be built?
                </Question>
            </div>
        </div>
    );
};

export const mapStateToProps = (state: Store.ApplyRootStateType) => {
    return {
        property: state.properties.items.find((itm) => itm.guid === state.properties.currentPropertyId),
    };
};

export const mapDispatchToProps = (dispatch: Store.ApplyDispatchType) => {
    const isNumeric = (str: string) => {
        if (typeof str != 'string') return false; // we only process strings!
        return (
            !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseInt(str))
        ); // ...and ensure strings of whitespace fail
    };

    const props: {
        onChange: (guid: string, value: string) => void;
        dispatch: Store.ApplyDispatchType;
    } = {
        onChange: (guid: string, value: string) => {
            if (isNumeric(value)) {
                dispatch(Store.PropertiesStore.Actions.updateBuildRentType(guid, parseInt(value)));
            } else {
                dispatch(Store.PropertiesStore.Actions.updateBuildRentType(guid, null));
            }
        },
        dispatch,
    };
    return props;
};

export default connect(mapStateToProps, mapDispatchToProps)(BuildRentTypeSelect);
